import axios from 'axios';
import store from 'store';

const state = {
  followups: [],
};

const getters = {};

const mutations = {
  setFollowUps: (st, payload) => {
    st.followups = payload;
  },
  addFollowUp: (st, payload) => {
    st.followups.push(payload);
  },
};

const actions = {
  getFollowUps: ({ commit }, payload) => {
    if (store.get('permissions').indexOf('leads.follow-ups.index') >= 0) {
      axios
        .get(`leads/${payload}/follow-ups`)
        .then(res => {
          commit('setFollowUps', res.data.data);
        })
        .catch();
    }
  },
  addFollowUp: ({ commit }, payload) => {
    commit('addFollowUp', payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/followUps.js